import { SBGModel } from "../models/SBGModel";
import API, { client } from "./API";

const SBGService = {
  async getAllSBGs() {
    const response = await API().get("SBG", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularSBG(sbg_id: number) {
    const response = await API().get("SBG");
    return response.data.filter(
      (cur_sbg: SBGModel) => cur_sbg.sbgid === sbg_id
    )[0];
  },
  async createSBG(data: SBGModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `SBG/${id}` : "SBG",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default SBGService;
